jQuery(document).ready(function ($) {
  $pageDrawer = $('.c-page-drawer');
  $pageDrawerButton = $('.js-page-drawer');
  $pageDrawerCloseButton = $('.c-page-drawer__close-btn');
  $pageDrawerOverlay = $('.c-page-drawer__overlay');

  $pageDrawerButton.click(function () {
    $(this).addClass('active');
    $drawerTitle = $(this).attr('data-title');
    $drawerName = $(this).attr('data-drawer-name');
    console.log($drawerName);
    $('.c-page-drawer__main')
      .find('[data-drawer-name=' + $drawerName + ']')
      .parent()
      .toggleClass('active-drawer-content');
    $('.c-page-drawer__title').html($drawerTitle);
    $('body').toggleClass('page-drawer-pushtoleft page-drawer-active');
    $('header').toggleClass('page-drawer-active');
    $pageDrawer.toggleClass('page-drawer-open');
  });

  function closeThem() {
    $pageDrawer = $('.c-page-drawer');
    $pageDrawerButton = $('.js-page-drawer');
    $pageDrawerButton.removeClass('active');
    $('.c-page-drawer__main > div').removeClass('active-drawer-content');
    $('body').removeClass('page-drawer-pushtoleft page-drawer-active');
    $('header').removeClass('page-drawer-active');
    $pageDrawer.removeClass('page-drawer-open');
  }

  $pageDrawerCloseButton.click(function () {
    closeThem();
  });
  $pageDrawerOverlay.click(function () {
    closeThem();
  });
});
